import { createAction } from '@reduxjs/toolkit';
import { UserSettings } from '../types';

export const getUserSettings = createAction('userSettings/get');
export const userSettingsResolved = createAction<UserSettings>(
	'userSettings/resolved',
);
export const userSettingsRejected = createAction('userSettings/rejected');
export const updateUserSettings = createAction<Partial<UserSettings>>(
	'userSettings/update',
);
export const updateUserSettingsResolved = createAction<UserSettings>(
	'userSettings/updateResolved',
);
export const updateUserSettingsRejected = createAction(
	'userSettings/updateRejected',
);
